const OVERLAY_PREFIX = '@OVERLAY';

export const SHOW = `${OVERLAY_PREFIX}/SHOW`;
export const HIDE = `${OVERLAY_PREFIX}/HIDE`;
